export default __webpack_public_path__ + "static/media/Grandeur_large_6.be6e33da.jpg";